import { useRef, useState } from "react";
const useChatbotState = (props)=>{
    const { componentVersion } = props;
    const [loadMoreMessages, setLoadMoreMessages] = useState(false);
    const [lastPromptId, setLastPromptId] = useState('');
    const audioPlayerRef = useRef(null);
    return {
        audioPlayerRef,
        loadMoreMessages,
        setLoadMoreMessages,
        lastPromptId,
        setLastPromptId,
        componentVersion
    };
};
export { useChatbotState };
